import { ModelGhost3d } from "../arrangement3d/ModelGhost3d";
import { Jaco } from "./Jaco";
import type { Model } from "./Model";

import { Object3D } from "three";

/**
 * ModelGhost ist eine performante Kopie eines Model, deren Darstellung sich stets mit dem Model synchronisiert.
 * So können mehrere gleiche Instanzen eines zugeschnittenen Balkens performant und speicherschonend in der Szene gehalten werden.
 */
export class ModelGhost extends Jaco {
  isModel = true;
  isGhost = true;

  /** @type {Model} */
  model: Model;
  _update3dCounter = 0;
  _used = false;
  oldchild3dContainer: Object3D | null | undefined = null;

  // fortlaufende Nummer: Wenn Profile nacheinander gestapelt werden, sollte diese Nummer fortlaufend sein. Wird für die Materialverschiebung verwendet.
  shuffleMaterialIndex = 0;

  constructor(parent: Jaco | null, model: Model) {
    super(parent);
    this.model = model;
  }

  update3d() {
    this._update3dCounter = Math.max(this.model._update3dCounter, this._update3dCounter + 1);
    if (this.model._update3dCounter < this._update3dCounter) {
      this.model.update3d();
      this.model._update3dCounter = this._update3dCounter;
    }
    super.update3d();
    // bei ModelGhosts kann sich aufgrund der Wiederverwendung der Parent ändern
    if (
      this.parent &&
      this.parent.child3dContainer &&
      this.oldchild3dContainer != null &&
      this.oldchild3dContainer !== this.parent.child3dContainer
    ) {
      if (this.jaco3d) {
        this.parent.child3dContainer.add(this.jaco3d);
      }
    }
    this.oldchild3dContainer = this.parent?.child3dContainer;
  }

  toJSON(): any {
    throw new Error("a GhostModel can not be persisted by default");
  }

  fromJSON(json: any): this {
    throw new Error("a GhostModel can not be persisted by default");
  }

  createJaco3d() {
    return new ModelGhost3d(this);
  }

  /** */
  getBox() {
    return this.model.getBox();
  }

  getMeta() {
    return this.model?.getMeta();
  }

  get key() {
    return this.model?.key;
  }
}
